import React from 'react';

import IMG_1 from '../../../Images/sliders/films-services/img_1.png';
import IMG_2 from '../../../Images/sliders/films-services/img_2.png';
import IMG_3 from '../../../Images/sliders/films-services/img_3.png';
import IMG_4 from '../../../Images/sliders/films-services/img_4.png';
import IMG_5 from '../../../Images/sliders/films-services/img_5.png';
import IMG_6 from '../../../Images/sliders/films-services/img_6.png';
import IMG_7 from '../../../Images/sliders/films-services/img_7.png';
import IMG_8 from '../../../Images/sliders/films-services/img_8.png';
import IMG_9 from '../../../Images/sliders/films-services/img_9.png';
import IMG_10 from '../../../Images/sliders/films-services/img_10.png';
import IMG_11 from '../../../Images/sliders/films-services/img_11.png';
import IMG_12 from '../../../Images/sliders/films-services/img_12.png';
import IMG_13 from '../../../Images/sliders/films-services/img_13.png';
import IMG_14 from '../../../Images/sliders/films-services/img_14.png';
import IMG_15 from '../../../Images/sliders/films-services/img_15.png';

export const Services_Title = [
  {
    textSize: '3.375rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => (
      <span>
        PRODUCTION
        <br />
        SERVICES
      </span>
    ),
  },
];

export const List_Title_1 = [
  {
    textSize: '2.25rem',
    marginBottom: '2.188rem',
    lineHeight: '100%',
    textMobile: '1.875rem',
    renderContent: () => <span>Creative & Writing</span>,
  },
];

export const List_1 = [
  {
    text: 'Writer’s room',
  },
  {
    text: 'Local research team',
  },
  {
    text: 'Scouting',
  },
  {
    text: 'Casting in Latin America',
  },
];

export const List_Title_2 = [
  {
    textSize: '2.25rem',
    marginBottom: '2.188rem',
    lineHeight: '100%',
    textMobile: '1.875rem',
    renderContent: () => <span>Production & Crew</span>,
  },
];

export const List_2 = [
  {
    text: 'International technical and creative team',
  },
  {
    text: 'Crew & Equipment',
  },
  {
    text: 'International health & safety protocols',
  },
  {
    text: 'Sustainable productions',
  },
];

export const List_Title_3 = [
  {
    textSize: '2.25rem',
    marginBottom: '2.188rem',
    lineHeight: '100%',
    textMobile: '1.875rem',
    renderContent: () => <span>Legal & Management</span>,
  },
];

export const List_3 = [
  {
    text: 'VAT Refund management',
  },
  {
    text: 'Legal management',
  },
  {
    text: 'Film commissions',
  },
  {
    text: 'Link to government entities',
  },
  {
    text: 'Local incentives',
  },
];

export const List_Title_4 = [
  {
    textSize: '2.25rem',
    marginBottom: '2.188rem',
    lineHeight: '100%',
    textMobile: '1.875rem',
    renderContent: () => <span>Post-Production</span>,
  },
];

export const List_4 = [
  {
    text: 'Post-production services',
  },
  {
    text: 'Editing & Compositing',
  },
  {
    text: 'Color-grading',
  },
  {
    text: 'Post-production',
  },
  {
    text: 'Supervision',
  },
];

export const List_Title_5 = [
  {
    textSize: '2.25rem',
    marginBottom: '2.188rem',
    lineHeight: '100%',
    textMobile: '1.875rem',
    renderContent: () => <span>Co-Production</span>,
  },
];

export const List_5 = [
  {
    text: 'Local e Internacional',
  },
];

export const SLIDER_IMAGES = [
  {
    img: IMG_1,
    alt: 'Img Services',
  },
  {
    img: IMG_2,
    alt: 'Img Services',
  },
  {
    img: IMG_3,
    alt: 'Img Services',
  },
  {
    img: IMG_4,
    alt: 'Img Services',
  },
  {
    img: IMG_5,
    alt: 'Img Services',
  },
  {
    img: IMG_6,
    alt: 'Img Services',
  },
  {
    img: IMG_7,
    alt: 'Img Services',
  },
  {
    img: IMG_8,
    alt: 'Img Services',
  },
  {
    img: IMG_9,
    alt: 'Img Services',
  },
  {
    img: IMG_10,
    alt: 'Img Services',
  },
  {
    img: IMG_11,
    alt: 'Img Services',
  },
  {
    img: IMG_12,
    alt: 'Img Services',
  },
  {
    img: IMG_13,
    alt: 'Img Services',
  },
  {
    img: IMG_14,
    alt: 'Img Services',
  },
  {
    img: IMG_15,
    alt: 'Img Services',
  },
];
